var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createRef, Component } from "react";
import echarts from 'echarts';
import { debounce } from 'throttle-debounce';
import moment from 'moment';
import ResizeObserver from 'resize-observer-polyfill';
function formatSeriesData(data) {
    return data.map(({ timestamp, value }) => ({
        name: timestamp,
        timestamp,
        value: [timestamp, value]
    }));
}
const formatTooltip = (params) => {
    return `${moment(params['value'][0]).fromNow()}: ${params['value'][1]}`;
};
export default class UnityHistogram extends Component {
    constructor() {
        super(...arguments);
        this.histRef = createRef();
        this.resizeChart = debounce(500, false, () => {
            var _a;
            (_a = this.chart) === null || _a === void 0 ? void 0 : _a.resize();
        });
        this.createChartOptions = () => {
            const { data = [], barColor = '#92b4dd', tooltipFormatter = formatTooltip, options = {} } = this.props;
            const defaultOptions = {
                title: {},
                grid: {
                    show: true,
                    containLabel: false,
                    top: 0,
                    left: 25,
                    right: 25,
                    bottom: 20,
                    borderColor: '#454545',
                    borderWidth: 1,
                },
                tooltip: {
                    transitionDuration: 0.2,
                    formatter: tooltipFormatter,
                    textStyle: {
                        fontFamily: 'Noto',
                        fontSize: 12
                    }
                },
                xAxis: {
                    show: true,
                    type: 'time',
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        fontSize: 10,
                        fontFamily: 'Noto'
                    },
                    splitNumber: 3
                },
                yAxis: {
                    show: false,
                    type: 'value'
                },
                series: [{
                        name: 'bar',
                        type: 'bar',
                        data: formatSeriesData(data)
                    }],
                animation: true,
                color: barColor ? [barColor] : undefined,
                animationDuration: 200
            };
            return Object.assign(Object.assign({}, defaultOptions), options);
        };
    }
    componentDidMount() {
        var _a;
        this.chart = echarts.init(this.histRef.current);
        const options = this.createChartOptions();
        this.chart.setOption(options);
        this.resizeObserver = new ResizeObserver(this.resizeChart);
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.observe(this.histRef.current);
    }
    componentDidUpdate(prevProps) {
        const { data = [], options = {} } = this.props;
        if (((prevProps === null || prevProps === void 0 ? void 0 : prevProps.data) !== data && (prevProps === null || prevProps === void 0 ? void 0 : prevProps.options) !== options) && !!this.chart) {
            const newOptions = this.createChartOptions();
            this.chart.setOption(newOptions);
        }
    }
    componentWillUnmount() {
        var _a;
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.unobserve(this.histRef.current);
        this.resizeChart.cancel();
    }
    render() {
        const _a = this.props, { data, options, tooltipFormatter, barColor, style } = _a, rest = __rest(_a, ["data", "options", "tooltipFormatter", "barColor", "style"]);
        return React.createElement("div", Object.assign({ style: Object.assign(Object.assign({}, styles.container), style), ref: this.histRef }, rest));
    }
}
const styles = {
    container: {
        minWidth: 0,
        flex: '1 1 auto'
    }
};
